export default function _pipeP(f, g) {
  return function () {
    var ctx = this;
    return f.apply(ctx, arguments).then(function (x) {
      return g.call(ctx, x);
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_pipeP.js
// module id = uFtl
// module chunks = 22